<div class="draft-desktop-heading">
  <span class="title-large-emphasized">Brogliacci</span>

  <button
    matButton="filled"
    type="button"
    class="desktop-new-draft-button"
    *uiCan="CAPS.brogliaccioCrea"
    [routerLink]="['new']"
  >
    <i class="fa-regular fa-plus" aria-hidden="true"></i>
    Nuovo brogliaccio
  </button>
</div>

<section class="draft-search">
  <span class="draft-search-title label-medium-emphasized">Ricerca brogliacci</span>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-date-field draft-date-field--from">
    <mat-label>Dal</mat-label>
    <input
      matInput
      [matDatepicker]="dateFromPicker"
      [(ngModel)]="dateFrom"
      placeholder="GG/MM/AAAA"
    />
    <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker" />
    <mat-datepicker #dateFromPicker />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-date-field draft-date-field--to">
    <mat-label>Al</mat-label>
    <input
      matInput
      [matDatepicker]="dateToPicker"
      [(ngModel)]="dateTo"
      placeholder="GG/MM/AAAA"
    />
    <mat-datepicker-toggle matIconSuffix [for]="dateToPicker" />
    <mat-datepicker #dateToPicker />
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="draft-status-field">
    <mat-label>Stato brogliaccio</mat-label>
    <mat-select multiple [(ngModel)]="selectedStatuses">
      @for (status of statusOptions; track status.value) {
        <mat-option [value]="status.value">{{ status.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <button matButton="filled" type="button" class="draft-search-button draft-search-button--desktop" (click)="cerca()">
    Cerca
  </button>

  @if (isLoading) {
    <ui-loading-spinner></ui-loading-spinner>
  } @else {
    <div class="draft-results">
      @for (brogliaccio of brogliacci; track brogliaccio.id) {
        <div
          class="draft-card"
          role="link"
          tabindex="0"
          (click)="apriDettaglio(brogliaccio.id)"
          (keydown.enter)="apriDettaglio(brogliaccio.id)"
        >
          <div class="draft-card-content">
            <div class="draft-card-column">
              <span class="body-medium-emphasized">
                Brogliaccio N° {{ brogliaccio.numeroBrogliaccio }}
              </span>
              <span class="body-medium">
                Data: {{ brogliaccio.data | date:'dd/MM/yyyy' }}
              </span>
              <span class="body-medium">
                {{ brogliaccio.numeroIncassi }}
                {{ brogliaccio.numeroIncassi === 1 ? 'incasso' : 'incassi' }}
              </span>
            </div>

            <div class="draft-card-column draft-card-column--end">
              <span class="body-medium-emphasized">
                {{ brogliaccio.importoTotale | currency:'EUR':'symbol':'1.2-2' }}
              </span>
              <span class="body-medium draft-status-badge" [ngClass]="statusBadgeClass(brogliaccio.situazione)">
                {{ brogliaccio.situazione }}
              </span>
            </div>
          </div>
          <div class="draft-card-action" aria-hidden="true">
            <i class="fa-regular fa-chevron-right"></i>
          </div>
        </div>
      } @empty {
        <span class="title-small">Nessun brogliaccio trovato</span>
      }
    </div>

    <ui-table-view
      class="draft-desktop-table"
      [columnsInfo]="brogliacciColumns"
      [data]="brogliacciTable"
      (rowClicked)="apriDettaglio($event.id)"
    />

    <mat-paginator
      class="draft-paginator"
      [length]="totalItems"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [pageSizeOptions]="[5, 10, 25]"
      [hidePageSize]="true"
      (page)="onPageChange($event)"
    >
    </mat-paginator>
  }
</section>

<button matFab extended type="button" class="new-draft-button" *uiCan="CAPS.brogliaccioCrea"
  [routerLink]="['new']">
  <i class="fa-regular fa-plus" aria-hidden="true"></i>
  <span class="new-draft-label title-medium">Nuovo brogliaccio</span>
</button>
